<template>
  <div>
    <a-descriptions
      :column="3"
      class="iotplt-descriptions iotplt-descriptions-max-6"
    >
      <a-descriptions-item label="月份">
        {{ data.month }}
      </a-descriptions-item>

      <a-descriptions-item label="状态">
        {{ data.status }}
      </a-descriptions-item>

      <a-descriptions-item label="结算金额(元)">
        {{ data.total_fee | formatCurrency }}
      </a-descriptions-item>
    </a-descriptions>

    <a-divider />

    <a-table
      style="overflow: auto"
      size="middle"
      :columns="tableColumns"
      :data-source="tableData"
      :pagination="false"
      :expand-icon="expandIcon"
      row-key="index"
    >
      <div
        slot="expandedRowRender"
        slot-scope="record"
      >
        <purchase-bill-list
          v-if="record.unit_type_slug === 'purchase'"
          :bill-id="agentMonthlyBillId"
        />
        <module-purchase-bill-list
          v-else-if="record.unit_type_slug === 'module_purchase'"
          :bill-id="agentMonthlyBillId"
        />
        <cpe-purchase-bill-list
          v-else-if="record.unit_type_slug === 'cpe_purchase'"
          :bill-id="agentMonthlyBillId"
        />
        <card-use-bill-list
          v-else-if="record.unit_type_slug === 'card_use'"
          :bill-id="agentMonthlyBillId"
        />
        <active-bill-list
          v-else-if="record.unit_type_slug === 'active'"
          :bill-id="agentMonthlyBillId"
        />
        <renew-bill-list
          v-else-if="record.unit_type_slug === 'renew'"
          :bill-id="agentMonthlyBillId"
        />
        <subscribe-bill-list
          v-else-if="record.unit_type_slug === 'subscribe'"
          :bill-id="agentMonthlyBillId"
        />
        <stop-bill-list
          v-else-if="record.unit_type_slug === 'stop'"
          :bill-id="agentMonthlyBillId"
        />
        <subscribe-traffic-pool-bill-list
          v-else-if="record.unit_type_slug === 'subscribe_traffic_pool'"
          :bill-id="agentMonthlyBillId"
        />
      </div>

      <span slot="actions" slot-scope="text, record">
        <a-space>
          <a v-if="record.unit_type_slug === 'active' || record.unit_type_slug === 'renew' || record.unit_type_slug === 'subscribe'" @click="exportData(record.unit_type_slug)">导出明细</a>
        </a-space>
      </span>
    </a-table>
  </div>
</template>

<script>
import { findAgentMonthlyBill, exportSimCardOrders } from '@/api/agent_monthly_bill'
import { formatBigNumber, formatCurrency } from '@/utils/filter'
import { exportExcel } from '@/api/excel'

export default {
  name: 'BalanceStatisticAgentMonthlyBillInfo',
  components: {
    PurchaseBillList: () => import('@/views/agent_monthly_bills/purchase/index'),
    ModulePurchaseBillList: () => import('@/views/agent_monthly_bills/module_purchase/index'),
    CpePurchaseBillList: () => import('@/views/agent_monthly_bills/cpe_purchase/index'),
    CardUseBillList: () => import('@/views/agent_monthly_bills/card_use/top_agent_self/index'),
    ActiveBillList: () => import('@/views/agent_monthly_bills/active/top_agent_self/index'),
    RenewBillList: () => import('@/views/agent_monthly_bills/renew/top_agent_self/index'),
    SubscribeBillList: () => import('@/views/agent_monthly_bills/subscribe/top_agent_self/index'),
    StopBillList: () => import('@/views/agent_monthly_bills/stop/top_agent_self/index'),
    SubscribeTrafficPoolBillList: () => import('@/views/agent_monthly_bills/subscribe_traffic_pool/top_agent_self/index')
  },
  data() {
    return {
      data: {},
      tableData: [],
      innerColumns: []
    }
  },
  computed: {
    agentType() {
      return this.$store.getters.userAgentType
    },

    tableColumns() {
      var columnArr = [
        {
          title: '账单类型',
          width: 350,
          dataIndex: 'unit_type'
        },
        {
          title: '个数',
          width: 250,
          customRender: formatBigNumber,
          dataIndex: 'bill_count'
        },
        {
          title: '结算金额(元)',
          customRender: formatCurrency,
          dataIndex: 'total_fee'
        },
        {
          title: '操作',
          dataIndex: 'actions',
          key: 'action',
          width: 80,
          scopedSlots: { customRender: 'actions' }
        }
      ]

      return columnArr
    },

    agentMonthlyBillId() {
      return parseInt(this.$route.params.id)
    },

    agentId() {
      return this.$store.getters.userAgentId
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    expandIcon({ expanded, expandable, record, onExpand }) {
      if (!expandable || record.bill_count === 0) return null

      return (
        <a onClick={e => onExpand(record, e)}>
          {expanded ? <a-icon type='minus-square' /> : <a-icon type='plus-square' />}
        </a>
      )
    },

    fetchData() {
      findAgentMonthlyBill(this.agentMonthlyBillId).then((res) => {
        this.data = res.data
        this.$store.dispatch('SetDynamicBreadCrumbsPlaceholder', { ':month': this.data.month })
        this.tableData = [
          { index: 0, unit_type: '卡采购账单', unit_type_slug: 'purchase', bill_count: this.data.purchased_count, total_fee: this.data.purchased_fee, total_commission_fee: this.data.purchased_commission_fee },
          { index: 1, unit_type: '模组采购账单', unit_type_slug: 'module_purchase', bill_count: this.data.module_purchased_count, total_fee: this.data.module_purchased_fee },
          { index: 2, unit_type: 'CPE采购账单', unit_type_slug: 'cpe_purchase', bill_count: this.data.cpe_purchased_count, total_fee: this.data.cpe_purchased_fee },
          { index: 3, unit_type: '激活账单', unit_type_slug: 'active', bill_count: this.data.actived_count, total_fee: this.data.actived_fee, total_commission_fee: this.data.actived_commission_fee },
          { index: 4, unit_type: '续期账单', unit_type_slug: 'renew', bill_count: this.data.renewed_count, total_fee: this.data.renewed_fee, total_commission_fee: this.data.renewed_commission_fee },
          { index: 5, unit_type: '套餐订购账单', unit_type_slug: 'subscribe', bill_count: this.data.subscribed_count, total_fee: this.data.subscribed_fee, total_commission_fee: this.data.subscribed_commission_fee },
          { index: 6, unit_type: '停机保号账单', unit_type_slug: 'stop', bill_count: this.data.stopped_count, total_fee: this.data.stopped_fee, total_commission_fee: this.data.stopped_commission_fee },
          { index: 7, unit_type: '流量使用详情账单', unit_type_slug: 'card_use', bill_count: this.data.card_used_count, total_fee: this.data.card_used_fee, total_commission_fee: this.data.card_used_commission_fee },
          { index: 8, unit_type: '流量池订购账单', unit_type_slug: 'subscribe_traffic_pool', bill_count: this.data.traffic_pool_subscribed_count, total_fee: this.data.traffic_pool_subscribed_fee, total_commission_fee: this.data.traffic_pool_subscribed_commission_fee }
        ]
      })
    },

    exportData(unitTypeSlug) {
      var type = 0
      switch (unitTypeSlug) {
        case 'active': {
          type = 5
          break
        }
        case 'renew': {
          type = 4
          break
        }
        case 'subscribe': {
          type = 1
          break
        }
      }

      exportSimCardOrders(this.agentMonthlyBillId, Object.assign({ agent_id: this.agentId }, {
        month: this.data.month,
        type: type
      })).then((res) => {
        if (res.code === 0 && res.data.is_direct_download) {
          exportExcel(res.data.id, res.data.file_name)
        }
      })
    }
  }
}
</script>

